

import FilloNavbar from "../components/FilloNavbar";
import HeroHeader from "../components/HeroHeader";
import KpiStrip from "../pages/dashboard/DashboardKPI.jsx";
import { Outlet, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import ScrollToTop from "../components/ScrollToTop.jsx";

export default function DashboardLayout() {
  const location = useLocation();
  const isPayroll = location.pathname.startsWith("/payroll");

  return (
    <div className="min-h-screen bg-[#12082F]">
      <FilloNavbar />

      {!isPayroll && (
        <>
          <HeroHeader />
          <KpiStrip />
        </>
      )}

      <motion.div
        id="page-content"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className={isPayroll ? "" : `
          max-w-[1400px]
          mx-auto
          mt-6 sm:mt-6 md:mt-[-90px]
          bg-white/90
          backdrop-blur-xl
          rounded-3xl
          shadow-2xl
          shadow-[#12082F]/60
          p-4 sm:p-6
          relative
        `}
      >
        <Outlet />
      </motion.div>
    </div>
  );
}


